import type { PermissionRole } from '@lucimark/shared/database/custom-types/permission-role'
import { permissionRoleSchema } from '@lucimark/shared/database/custom-types/permission-role'
import { z } from 'zod'

export interface IPermissionPayload {
  userId: string
  role: PermissionRole
}

export interface IPermissionRecord extends IPermissionPayload {
  email: string
  picture: string
}

export interface IPermission extends IPermissionRecord {
  tenantId: string
  tenantName: string
}

export const userInvitationSchema = z.object({
  email: z.email(),
  role: permissionRoleSchema,
  isOwner: z.boolean().optional()
})

export type TUserInvitation = z.infer<typeof userInvitationSchema>

export interface IUserInvitationResponse extends TUserInvitation {
  iat: number
  token: string
}

export interface IUserInvitation extends IUserInvitationResponse {
  secret: string
}

/** Pending tenant invitation for the logged-in user (no token/secret). */
export interface TPendingUserInvitation {
  tenantId: string
  tenantName: string
  role: PermissionRole
  isOwner: boolean
  email: string
  invitedAt: string
  lastSentAt: string | null
}
